import React from 'react'
import { get } from 'lodash'
import Html from 'src/components/Html/Html'
import { formatDate, formatMillion } from '../../utils/functions'
import FourColumnsDatapoints from '../FourColumnsDatapoints'
import AsOfDate from '../AsOfDate'

export default function FundFacts({
  data = {},
  fundClass = {},
  inceptionDate,
  fundTitle,
  popups,
}) {
  const {
    valuation,
    publicFundNumber,
    fundComposite,
    // Index data
    index_ticker,
    holdings_characteristics,
  } = data || {}
  const { expense_ratio, inception_date, ticker } = fundClass || {}
  const share_class = get(fundClass, 'share_class[0].title')
  const date = get(valuation, 'calendar.date')

  const createPopover = (popup) => {
    if (!popup || popup.length !== 1) return null
    return {
      htmlContent: popup[0].html.map((html, index) => (
        <p key={`expense-ratio-${index}`}>
          <Html content={html} nowrap={true} />
        </p>
      )),
      text: popup[0].text,
    }
  }

  const datapoints = [
    inception_date || inceptionDate
      ? {
          label: 'Inception Date',
          value: formatDate(inception_date || inceptionDate),
        }
      : null,
    expense_ratio?.net
      ? {
          label: 'Net Expense Ratio',
          labelHasPopover: expense_ratio?.net_popup?.[0]?.html,
          popover: createPopover(expense_ratio.net_popup),
          value: expense_ratio.net || '--',
        }
      : null,
    expense_ratio?.gross
      ? {
          label: 'Gross Expense Ratio',
          labelHasPopover: expense_ratio?.gross_popup?.[0]?.html,
          popover: createPopover(expense_ratio.gross_popup),
          value: expense_ratio.gross || '--',
        }
      : null,
    expense_ratio?.adjusted
      ? {
          label: 'Adjusted Expense Ratio',
          labelHasPopover: expense_ratio?.adjusted_popup?.[0]?.html,
          popover: createPopover(expense_ratio.adjusted_popup),
          value: expense_ratio.adjusted || '--',
        }
      : null,
    fundComposite?.compositeValuation?.tna && date > inception_date
      ? {
          label: 'Total Fund Net Assets (million)',
          labelHasAsOfDate: true,
          labelAsOfDate: `As of ${formatDate(fundComposite.compositeValuation.calendar.date)}`,
          value: `$${formatMillion(fundComposite.compositeValuation.tna, 3)}`,
        }
      : null,
    valuation && date > inception_date
      ? {
          label: 'Total Share Class Net Assets (million)',
          labelHasAsOfDate: true,
          labelAsOfDate: `As of ${formatDate(date)}`,
          value: `$${formatMillion(valuation.tna, 3)}`,
        }
      : null,
    ticker ? { label: 'Ticker', value: ticker || '--' } : null,
    publicFundNumber
      ? { label: 'Fund Number', value: publicFundNumber || '--' }
      : null,
    // Index data
    index_ticker && fundTitle
      ? { label: 'Index Name', value: fundTitle }
      : null,
    index_ticker
      ? { label: 'Index Symbol', value: index_ticker || '--' }
      : null,
    holdings_characteristics?.number_of_holdings
      ? {
          label: 'Number of Constituents',
          value: holdings_characteristics.number_of_holdings,
        }
      : null,
    valuation?.index_valuation_amount
      ? {
          label: 'Total Return Index Closing Value',
          value: `${valuation.index_valuation_amount}`,
          labelHasPopover: !!popups?.find(
            (p) => p.field_name === 'index_valuation_amount'
          ),
          popover: popups?.find(
            (p) => p.field_name === 'index_valuation_amount'
          ),
        }
      : null,
    holdings_characteristics?.total_index_market_cap
      ? {
          label: 'Total Index Market Capitalization (Millions)',
          value: `${formatMillion(
            holdings_characteristics.total_index_market_cap,
            3
          )}`,
          labelHasPopover: !!popups?.find(
            (p) => p.field_name === 'total_index_market_cap'
          ),
          popover: popups?.find(
            (p) => p.field_name === 'total_index_market_cap'
          ),
        }
      : null,
  ].filter(Boolean)

  while (datapoints.length % 4 !== 0) {
    datapoints.push({})
  }

  if (share_class) {
    datapoints.push({
      label: 'Share Class',
      value: share_class || '--',
      valueFontSize: '24px',
      valueFontWeight: '500',
    })
  }

  let tempArray = []

  return (
    <div>
      <AsOfDate date={date} />
      {datapoints.map((datapoint, index) => {
        if (index % 4 === 0) {
          tempArray = []
          tempArray.push(datapoint)
        } else {
          tempArray.push(datapoint)
        }

        if (tempArray.length === 4 || index === datapoints.length - 1) {
          return <FourColumnsDatapoints datapoints={tempArray} key={index} />
        }

        return <div key={index} />
      })}
    </div>
  )
}
